import React from 'react';
import SeoMetadata from '../components/Seo/SeoMetadata';
import TituloPlafonFalso from '../components/sections/TechoPlafonFalso/TituloPlafonFalso';
import IntroPlafonFalso from '../components/sections/TechoPlafonFalso/IntroPlafonFalso'; 
import DescripcionPlafonFalso from '../components/sections/TechoPlafonFalso/DescripcionPlafonFalso';
import FormularioContactoPlafon from '../components/sections/TechoPlafonFalso/FormularioContactoPlafon';
import Header from '../components/layouts/Header';
import Footer from '../components/layouts/Footer'; 

const TechoPlafonFalsoPage = () => {
  return (
    <div>
      <SeoMetadata
        title="Techo y Plafón Falso de PVC | Decototal"
        description="Conoce las opciones de plafón falso de PVC para renovar techos y espacios interiores. Revisa sus aplicaciones y solicita una cotización."
        keywords="plafón falso PVC, techo de PVC, plafón decorativo, recubrimiento para techo"
        path="/techo-plafon-falso-page"
        image="/assets/img/productos/techo-plafon-falso/plafon-falso-titulo.jpg"
      />
      <Header />
        <TituloPlafonFalso />  
        <IntroPlafonFalso />  
        <DescripcionPlafonFalso />   
        <FormularioContactoPlafon />
      <Footer /> 
    </div>
  );
};

export default TechoPlafonFalsoPage;